export default ".otpcls{\n    color: red;\n    font-size: 14px;\n}\n\n.specialcolor{\n    color: #88318A;\n}\n\n.normalcolor{\n    color: black;\n}";